import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../../applications/hooks/UseAuth'
import ContentView from '../../../components/PageView/Content'
import CustomerOrderService from '../services/CustomerOrder'
import { CustomerOrderForm } from './CustomerOrderForm'
import CustomerOrderContext from '../utils/hooks/CustomerOrderContext'

function CustomerOrderView(props) {
    const { addReturnButton, recordForEdit } = props
    const { haveAccessTo } = useAuth()
    const location = useLocation()
    const dataId = location.pathname.split('/').pop()
    console.log('customer : ', dataId)
    const customerOrderService = CustomerOrderService.load()
    const [needLoad, setNeedLoad] = useState(true)
    const [needLoadCode, setNeedLoadCode] = useState(true)
    return (
        <>
            <ContentView
                dataId={recordForEdit ? recordForEdit.code : dataId}
                title={recordForEdit ? '' : `Modification client`}
                addReturnButton={addReturnButton}
                service={customerOrderService}
                haveAccessTo={haveAccessTo}
                setNeedLoad={setNeedLoad}
                needLoad={needLoad}
                Form={CustomerOrderForm}
                needLoadCode={needLoadCode}
            />
        </>
    )
}

export default CustomerOrderView
